import { ProjectPlanData } from '@/features/subscriptions/types/subscription-types';

export const projectPlans: ProjectPlanData[] = [
  {
    id: 'client_core',
    planType: 'client_core',
    type: 'project',
    hasTrial: false,
    entitlements: {
      seats: 1,
      subprojects: 1,
      standardKpis: 3,
      derivativeKpis: 1,
    },
  },
  {
    id: 'client_growth',
    planType: 'client_growth',
    type: 'project',
    hasTrial: false,
    entitlements: {
      seats: 3,
      subprojects: 3,
      standardKpis: 6,
      derivativeKpis: 3,
    },
  },
  {
    id: 'client_scale',
    planType: 'client_scale',
    type: 'project',
    hasTrial: false,
    entitlements: {
      seats: 5,
      subprojects: 6,
      standardKpis: null,
      derivativeKpis: null,
    },
  },
];
